if (!window.__shDiscountBoxCartSync) {
  window.__shDiscountBoxCartSync = true;

  const CART_JS_URL = '/cart.js';
  const CART_PATH = /\/cart\/(add|change|update|clear)/i;

  const refreshDiscountBoxes = (cart) => {
    document.querySelectorAll('sh-discount-box').forEach((box) => {
      if (typeof box.applyCart !== 'function') return;
      if (cart && cart.items) {
        box.applyCart(cart);
        return;
      }
      box.fetchCart();
    });
  };

  const fetchLiveCart = () => {
    fetch(CART_JS_URL, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.json())
      .then((cart) => refreshDiscountBoxes(cart))
      .catch(() => {});
  };

  window.__shDiscountBoxFetchCart = fetchLiveCart;

  const originalFetch = window.fetch;
  window.fetch = function patchedFetch(...args) {
    const result = originalFetch.apply(this, args);
    const request = args[0];
    const url = typeof request === 'string' ? request : request && request.url ? request.url : '';

    if (CART_PATH.test(String(url))) {
      result
        .then(() => {
          window.setTimeout(fetchLiveCart, 50);
        })
        .catch(() => {});
    }

    return result;
  };

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail && event.detail.cart;
    if (cart && cart.items) {
      refreshDiscountBoxes(cart);
      return;
    }
    fetchLiveCart();
  });

  document.addEventListener('ajaxProduct:added', () => {
    fetchLiveCart();
  });

  const bindUpcart = () => {
    if (window.__shDiscountBoxUpcartBound) return true;

    if (typeof window.upcartSubscribeCartUpdated !== 'function') return false;

    const onUpcartCart = (event) => {
      const cart = event && event.cart;
      if (cart && cart.items) {
        refreshDiscountBoxes(cart);
        return;
      }
      fetchLiveCart();
    };

    window.upcartSubscribeCartUpdated(onUpcartCart);
    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(onUpcartCart);
    }
    if (typeof window.upcartSubscribeAddedToCart === 'function') {
      window.upcartSubscribeAddedToCart(() => fetchLiveCart());
    }
    if (typeof window.upcartSubscribeItemRemoved === 'function') {
      window.upcartSubscribeItemRemoved(() => fetchLiveCart());
    }
    if (typeof window.upcartSubscribeCartClosed === 'function') {
      window.upcartSubscribeCartClosed(() => fetchLiveCart());
    }

    window.__shDiscountBoxUpcartBound = true;
    fetchLiveCart();
    return true;
  };

  if (!bindUpcart()) {
    const timer = window.setInterval(() => {
      if (bindUpcart()) window.clearInterval(timer);
    }, 250);
    window.setTimeout(() => window.clearInterval(timer), 20000);
  }
}

if (!customElements.get('sh-discount-box')) {
  customElements.define(
    'sh-discount-box',
    class ShDiscountBox extends HTMLElement {
      connectedCallback() {
        this.productId = String(this.dataset.productId || '');
        this.price = Number(this.dataset.price || 0);
        this.suffix = this.dataset.priceSuffix || '';
        this.steps = Array.from(this.querySelectorAll('[data-sh-discount-step]'));
        this.cartQty = Number(this.dataset.productQty || 0);
        this.selectedIndex = -1;

        this.onCartUpdate = this.onCartUpdate.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onDotClick = this.onDotClick.bind(this);
        this.onQuantityInputChange = this.onQuantityInputChange.bind(this);

        if (window.theme && theme.pubsub) {
          this.unsubscribeCart = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.onCartUpdate
          );
          this.unsubscribeVariant = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.variantChange,
            this.onVariantChange
          );
        }

        this.addEventListener('click', this.onDotClick);
        document.addEventListener('change', this.onQuantityInputChange);
        document.addEventListener('input', this.onQuantityInputChange);
        this.syncSelectedFromQuantityInput();
        this.updatePrices();
        this.fetchCart();
      }

      disconnectedCallback() {
        if (this.unsubscribeCart) this.unsubscribeCart();
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        this.removeEventListener('click', this.onDotClick);
        document.removeEventListener('change', this.onQuantityInputChange);
        document.removeEventListener('input', this.onQuantityInputChange);
      }

      onCartUpdate(event) {
        const cart = event && event.cart;
        if (cart && cart.items) {
          this.applyCart(cart);
          return;
        }
        this.fetchCart();
      }

      onVariantChange(event) {
        const data = event && event.data;
        if (!data || !data.variant) return;
        if (data.productId && String(data.productId) !== this.productId) return;
        this.price = Number(data.variant.price || 0);
        this.updatePrices();
        this.syncSelectedFromQuantityInput();
      }

      fetchCart() {
        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then((response) => response.json())
          .then((cart) => this.applyCart(cart))
          .catch(() => {});
      }

      getItemProductId(item) {
        if (!item) return '';
        if (item.product_id) return item.product_id;
        if (item.productId) return item.productId;
        if (item.product && item.product.id) return item.product.id;
        return '';
      }

      applyCart(cart) {
        if (!cart || !Array.isArray(cart.items) || !this.productId) return;

        const qty = cart.items.reduce((sum, item) => {
          if (String(this.getItemProductId(item)) === this.productId) {
            return sum + Number(item.quantity || 0);
          }
          return sum;
        }, 0);

        this.cartQty = qty;
        this.dataset.productQty = String(qty);
        this.syncSelectedFromQuantityInput();
      }

      getQuantityInput() {
        const info = document.querySelector('product-info[data-product-id="' + this.productId + '"]');
        if (info) {
          const scoped = info.querySelector('.sh-quantity-box input[name="quantity"]');
          if (scoped) return scoped;
        }

        return document.querySelector('.sh-quantity-box input[name="quantity"]');
      }

      onDotClick(event) {
        const dot = event.target.closest('[data-sh-discount-dot]');
        if (!dot || !this.contains(dot)) return;
        const step = dot.closest('[data-sh-discount-step]');
        if (!step) return;
        this.setQuantity(Number(step.dataset.qty || 0));
        this.syncSelectedFromQuantityInput();
      }

      onQuantityInputChange(event) {
        const input = event.target;
        if (!input || input.name !== 'quantity') return;
        if (!input.closest('.sh-quantity-box')) return;
        this.syncSelectedFromQuantityInput();
      }

      setQuantity(qty) {
        const input = this.getQuantityInput();
        if (!input) return;

        let next = Number(qty || 0);
        const min = Number(input.min || input.getAttribute('data-min') || 1);
        const maxValue = input.max || input.getAttribute('data-max');
        const max = maxValue ? Number(maxValue) : null;
        if (next < min) next = min;
        if (max != null && !Number.isNaN(max) && next > max) next = max;

        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      inputQty() {
        const input = this.getQuantityInput();
        const qty = input ? Number(input.value || 0) : 0;
        return Number.isNaN(qty) || qty < 0 ? 0 : qty;
      }

      progressQty() {
        return Math.max(Number(this.cartQty) || 0, this.inputQty());
      }

      syncSelectedFromQuantityInput() {
        const qty = this.progressQty();
        let selected = -1;
        this.steps.forEach((step, index) => {
          if (qty >= Number(step.dataset.qty || 0)) selected = index;
        });
        this.selectedIndex = selected;
        this.renderStates(qty);
      }

      fulfilledIndex() {
        let reached = -1;
        this.steps.forEach((step, index) => {
          if (this.cartQty >= Number(step.dataset.qty || 0)) reached = index;
        });
        return reached;
      }

      progressFill(qty) {
        const thresholds = this.steps.map((step) => Number(step.dataset.qty || 0));
        if (!thresholds.length) return 0;
        if (qty < thresholds[0]) return 0;

        const last = thresholds.length - 1;
        if (qty >= thresholds[last]) return 100;

        let index = 0;
        for (let i = 0; i < last; i += 1) {
          if (qty >= thresholds[i]) index = i;
        }

        const start = thresholds[index];
        const end = thresholds[index + 1];
        const span = end - start;
        const t = span > 0 ? (qty - start) / span : 0;
        return ((index + t) / last) * 100;
      }

      renderStates(qty) {
        const quantity = Number(qty);
        const selectedQty = Number.isNaN(quantity)
          ? Number(this.getQuantityInput() && this.getQuantityInput().value) || 0
          : quantity;

        this.style.setProperty('--sh-discount-fill', String(this.progressFill(selectedQty)));
        this.setAttribute('data-reached', String(this.selectedIndex));

        this.steps.forEach((step, index) => {
          const reached = index <= this.selectedIndex;
          step.setAttribute('data-state', reached ? 'completed' : 'upcoming');
          step.toggleAttribute('data-latest', reached && index === this.selectedIndex);
          const dot = step.querySelector('[data-sh-discount-dot]');
          if (dot) dot.setAttribute('aria-pressed', index === this.selectedIndex ? 'true' : 'false');
        });
      }

      updatePrices() {
        const format = this.dataset.moneyFormat || this.getThemeMoneyFormat();

        this.steps.forEach((step) => {
          const percent = Number(step.dataset.percent || 0);
          const cents = Math.round((this.price * (100 - percent)) / 100);
          const priceEl = step.querySelector('[data-sh-discount-price]');
          if (!priceEl) return;

          let formatted = String(cents);
          if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
            formatted = theme.Currency.formatMoney(cents, format);
          }

          priceEl.textContent = `${formatted}${this.suffix}`;
        });
      }

      getThemeMoneyFormat() {
        if (!window.theme || !theme.settings) return '{{amount}}';
        if (theme.settings.currencyCodeEnabled) return theme.settings.moneyWithCurrencyFormat;
        return theme.settings.moneyFormat;
      }
    }
  );
}
